export class Icon {
  css = "";
  color = "";
  name?: string;
}

export class Annotation {
  id = "";
  type = "";
  xMin?: number; 
  xMax?: number;
  yMin?: number; 
  yMax?: number;
  borderColor?: string;
  borderWidth?: number;
  backgroundColor?: string;
  z?: number;
}

export class Options {
  responsive = false;
  maintainAspectRatio = false;
  plugins!: Plugins;
  scales!: Scales;
}

class Plugins {
  datalabels!: Datalabels;
  propagate = false;
  legend!: Legend;
  annotation!: Annotations;
}

class Datalabels {
  clip?: boolean;
  display = false;
  align?: string;
  font?: (context: any) => Font;
  formatter?: any;
}

class Font {
  weight = "";
  size = 0;
}

class Legend {
  display = false;
}

class Annotations {
  common!: Common;
  annotations: Annotation[] = [];
}

class Common {
  drawTime = "";
}

class Scales {
  y!: Y;
}

class Y {
  max = 0;
  min = 0;
  ticks!: Ticks;
}

class Ticks {
  stepSize = 0;
}

export class ChartData {
  labels: string[][] = [];
  datasets: Dataset[] = [];
}

class Dataset {
  pointBackgroundColor!: (value: any) => string;
  borderColor = "";
  parsing = false;
  borderWidth = 0;
  pointRadius!: (context: any) => number;
  datalabels!: Datalabels;
  data: Data[] = [];
  spanGaps = false;
}

export class DataContent {
  median = "";
  high = "";
  low = "";
  dataSet: Data[] = [];
  dataPoints: DataPoint[] = [];
}

export class Assessment {
  median = "";
  high = "";
  low = "";
}

export class Data {
  x = 0.0;
  y = 0;
}

export class DataPoint {
  multiple = true;
  y = 0;
  x = 0.0;
}

export class PatientInfo {
  patientName = "";
  patientId = "";
}

export class PatientDDL {
  text = "";
  value = "";
}

export class AlertZone {
  color = "";
  startZone = 0;
  endZone = 0;
}

export enum LevelColor {
  MostSevere = "#FAABAB",
  Severe = "#F6DDAD",
  Moderate = "#F9E7C4",
  Mild = "#C5DAB4",
  Minimal = "#DFEBD6"
}

export enum AssessmentTypes {
  GAD7 = 1,
  PHQ9 = 2,
  SOWS = 3,
  Cravings = 4
}